<template>
    <div>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="商品名字" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="商品类型" prop="schema_name">
                        <el-select v-model="form.schema_name" placeholder="商品类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of schema_name_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="商品状态" prop="status">
                        <el-select v-model="form.status" placeholder="请选择商品状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of status" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <h3>
            <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </h3>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="name" label="商品名字" fixed="left"></el-table-column>
            <el-table-column prop="timetype" label="商品类型" align="center">
                <template slot-scope="scope">
                    {{ schema_name[scope.row.schema_name] }}
                </template>
            </el-table-column>
            <el-table-column prop="timetype" label="平台卡类型" align="center">
                <template slot-scope="scope">
                    {{ scope.row.schema_name === 'platform_times_card' ? platform_times_card_type[scope.row.type] : '-'}}
                </template>
            </el-table-column>
            <el-table-column prop="max" label="最大供应数量" align="center"></el-table-column>
            <el-table-column prop="minted" label="已购买次数" align="center"></el-table-column>
            <el-table-column prop="points" label="购买消耗积分" align="center"></el-table-column>
            <el-table-column prop="available_times" label="获得免费次数" align="center">
                <template slot-scope="scope">
                    {{ scope.row.schema_name === 'redeem_code' ? 1 : scope.row.schema_name === 'information_package_download' ? '不限次数' : scope.row.available_times }}
                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    {{ scope.row.is_over === 1 ? '已售完' : scope.row.status === 'open' ? '进行中' : '暂停' }}
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <add-modal :dialogVisible="addFlag" :info="info" :schema_name_list="schema_name_list" :platform_times_card_list="platform_times_card_list" @closeModal="closeAddModal" v-if="addFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddModal from './add/index.vue';
export default {
    components: {
        AddModal,
    },
    data() {
        return {
            status: [
                { label: '进行中', value: 'open' },
                { label: '暂停', value: 'close' },
                { label: '已售完', value: 'over' },
            ],
            schema_name_list: [
                { label: '第三方平台推荐码', value: 'redeem_code' },
                { label: '资料包PDF下载', value: 'information_package_download' },
                { label: '平台次数卡', value: 'platform_times_card' },
            ],
            schema_name: {
                redeem_code: '第三方平台推荐码',
                information_package_download: '资料包PDF下载',
                platform_times_card: '平台次数卡',
            },
            platform_times_card_list: [
                // { label: '创建prompt次数卡', value: 'created_text_prompt' },
                { label: '获取Prompt评分卡', value: 'get_prompt_score' },
                { label: '优化次数卡', value: 'optimize_prompt' },
                { label: '生成图片次数卡', value: 'make_visual_images' },
            ],
            platform_times_card_type: {
                created_text_prompt: '创建prompt次数卡',
                get_prompt_score: '获取Prompt评分卡',
                optimize_prompt: '优化次数卡',
                make_visual_images: '生成图片次数卡',
            },
            form: {
                name: '',
                schema_name: '',
                status: '',
            },
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            //
            info: {},
            rule_list: [],
            addFlag: false,
        };
    },
    created() {
        this.getVoucherList();
    },
    methods: {
        async getVoucherList(_params = {}) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.voucherList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handleCurrentChange(val) {
            this.getVoucherList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getVoucherList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getVoucherList(this.form);
        },

        handleAdd() {
            this.info = {};
            this.addFlag = true;
        },
        edit(data) {
            this.info = data;
            this.addFlag = true;
        },
        closeAddModal() {
            this.addFlag = false;
            this.getVoucherList();
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
    button {
        width: 100px;
    }
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
